var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3921_1103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7333 8.67509C13.4083 9.00009 12.8667 9.00009 12.5417 8.67509L8.81665 4.95842L2.94165 10.8251L2.39165 10.3001C1.41665 9.32509 1.41665 7.74176 2.39165 6.76676L5.92498 3.23342C6.89998 2.25842 8.48332 2.25842 9.45832 3.23342L13.7333 7.50009C14.0583 7.82509 14.0583 8.35009 13.7333 8.67509ZM14.3167 6.90842C14.9667 7.55842 14.9667 8.61676 14.3167 9.26676C13.2583 10.3251 12.1417 9.45009 11.9583 9.26676L8.82498 6.13342L4.18332 10.7751C3.85832 11.1001 3.85832 11.6251 4.18332 11.9501C4.50832 12.2751 5.03332 12.2751 5.36665 11.9501L9.21665 8.10009L9.80832 8.69176L5.95832 12.5418C5.63332 12.8668 5.63332 13.3918 5.95832 13.7168C6.28332 14.0418 6.80832 14.0418 7.14165 13.7168L10.9917 9.86676L11.5833 10.4584L7.73332 14.3084C7.40832 14.6334 7.40832 15.1584 7.73332 15.4834C8.05832 15.8084 8.58332 15.8084 8.90832 15.4834L12.7583 11.6334L13.35 12.2251L9.49998 16.0751C9.17498 16.4001 9.17498 16.9251 9.49998 17.2501C9.82498 17.5751 10.35 17.5751 10.675 17.2501L17.6083 10.3001C18.5833 9.32509 18.5833 7.74176 17.6083 6.76676L14.075 3.23342C13.1167 2.27509 11.5667 2.25842 10.5917 3.18342L14.3167 6.90842Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3921_1103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare);
export default __webpack_public_path__ + "static/media/care.5b93f39e377efdee1be6945bc109d193.svg";
export { ForwardRef as ReactComponent };